import React from "react";
import { motion } from "framer-motion";
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <section className="newletter">
        <div className="background-objects">
          <motion.img
            src="/images/book.png"
            alt="book"
            className="fly book"
            animate={{ y: [0, -20, 0], rotate: [0, 5, -5, 0] }}
            transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
          />
          <motion.img
            src="/images/pen.png"
            alt="pen"
            className="fly pen"
            animate={{ y: [0, 25, 0], rotate: [0, -8, 8, 0] }}
            transition={{ repeat: Infinity, duration: 7, ease: "easeInOut" }}
          />
        </div>

        <div className="container flexSB">
          <motion.div
            className="left row"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Edu Masr</h1>
            <span>
              🔥 خُد أول خطوة في رحلتك للنجاح… وابدأها من منصة مستر <br /> Edu Masr
            </span>
          </motion.div>

          <motion.div
            className="right row social-icons"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              className="icon facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noreferrer"
              className="icon youtube"
            >
              <FaYoutube />
            </a>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Footer;
